import React from 'react'
import { useEmoji, useShortcode } from 'state/emoji/mutators'
import { ColorWrapper, EmojiWrapper, Background } from './s'
import { prune } from 'utilities/array'
import { cls } from 'utilities/dom'
import { percentageToAngle } from 'utilities/math'

const DisplaySymbol = ({ symbol, icon = null, percentage = 100, size = 40, inline = false, disabled = false, ...props }) => {
    const {
        emoji: name,
        emojiUnicode: emoji,
        color = '#f5f4f3',
        colorToken = 'symbol-neutral-1'
    } = symbol ?? {}

    const className = cls([
        props.className,
        inline && 'inline',
        disabled && 'disabled'
    ])

    return (
        <ColorWrapper
            {...props}
            {...(className ? { className } : null)}
            style={{ '--symbol-size': `${size}px` }}>
            {(name || emoji) && (
                <DisplayEmoji
                    name={name}
                    emoji={emoji} />
            )}
            {icon}
            <Background
                style={{
                    '--symbol-color': color,
                    '--symbol-color-token': `var(--huma-color-${colorToken ?? 'symbol-neutral-1'})`,
                    '--symbol-angle': `${percentageToAngle(percentage)}deg`
                }} />
        </ColorWrapper>
    )
}

export const DisplayEmoji = ({
    name: initialName, emoji: initialEmoji,
    fallbackName, fallbackEmoji,
    size, className, naked = false
}) => {
    const emojiResolved = useEmoji({
        shortcode: initialName,
        queryOptions: {
            enabled: !!initialName && !initialEmoji
        }
    })

    const shortcodeResolved = useShortcode({
        emoji: initialEmoji,
        queryOptions: {
            enabled: !!initialEmoji && !initialName
        }
    })

    const emoji = emojiResolved ?? shortcodeResolved ?? ((!!initialEmoji || (!!initialName && !fallbackEmoji)) ? {
        name: initialName,
        emoji: initialEmoji
    } : {
        name: fallbackName,
        emoji: fallbackEmoji
    })

    if(naked) {
        return emoji.emoji
    }

    className = cls([
        className,
        'emoji'
    ])

    return (
        <EmojiWrapper
            {...(className ? { className } : null)}
            {...(!!size ? { style: { '--__huma-component-font-size': `${size}px` } } : null)}>
            {!!emoji.emoji && (
                <span aria-label={prune([
                    emoji.emoji,
                    emoji.name
                ]).join(', ')}>
                    {emoji.emoji}
                </span>
            )}
        </EmojiWrapper>
    )
}

export default DisplaySymbol